<template>
  <div class="side-effects">
    <OnlineOffline />
    <OrderDetail />
    <Interrupt361 />
    <SideStockTrade />
    <SideStockView />
  </div>
</template>
<script>
import OnlineOffline from './OnlineOffline'
import OrderDetail from './OrderDetail'
import Interrupt361 from './Interrupt361'
import SideStockTrade from './SideStockTrade'
import SideStockView from './SideStockView'

export default {
  name: 'SideEffects',
  components: {
    Interrupt361,
    OnlineOffline,
    OrderDetail,
    SideStockTrade,
    SideStockView
  }
}
</script>
